import React from 'react';
import { ExpandButton, StyledSelectableAccordionButton } from './SelectableAccordionButton.styles';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

interface Props {
  id: string;
  panelId: string;
  isExpanded: boolean;
  isSelected?: boolean;
  children: React.ReactNode;
  onToggleExpand(): void;
  onClick?(): void;
  variant?: 'primary' | 'secondary';
}

export const SelectableAccordionButton = ({
  children,
  id,
  isExpanded,
  onClick,
  panelId,
  onToggleExpand,
  isSelected,
  variant = 'primary',
}: Props) => {
  return (
    <Box position="relative">
      <StyledSelectableAccordionButton
        as={onClick ? 'button' : 'div'}
        id={id}
        role="button"
        tabIndex={0}
        onClick={onClick}
        variant={variant}
        isSelected={isSelected}
        isSelectable={!!onClick}
        aria-expanded={isExpanded}
        aria-controls={panelId}
      >
        {children}
      </StyledSelectableAccordionButton>

      <ExpandButton
        isSelected={isSelected}
        variant={variant}
        onClick={evt => {
          evt.stopPropagation();
          onToggleExpand();
        }}
        aria-label={isExpanded ? 'Collapse' : 'Expand'}
      >
        <Icon className={isExpanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'} />
      </ExpandButton>
    </Box>
  );
};
